import type { ReactNode } from 'react';

import { GlassButton } from '../GlassButton';

import styles from './UpdateToast.module.scss';

// The "an update is waiting" notice, shared by PWAUpdateToast (service worker) and
// NativeUpdateToast (TestFlight/Play). Same slot, same look — they must never drift.
// Purely presentational: what "apply the update" means differs per platform, so the
// caller owns onAction and toast lifecycle.
export type UpdateToastProps = {
  // Rendered twice — as the badge and inside the action button.
  icon: ReactNode;
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
  onDismiss: () => void;
};

export default function UpdateToast({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  onDismiss,
}: UpdateToastProps) {
  return (
    <div className={styles.toast}>
      <div className={styles.icon} aria-hidden="true">
        {icon}
      </div>

      <div className={styles.content}>
        <div className={styles.header}>
          <div>
            <p className={styles.title}>{title}</p>
            <p className={styles.description}>{description}</p>
          </div>

          <button
            type="button"
            className={styles.closeButton}
            onClick={onDismiss}
            aria-label="Dismiss update notification"
          >
            ×
          </button>
        </div>

        <div className={styles.actions}>
          <GlassButton size={32} className={styles.actionButton} onClick={onAction}>
            {icon}
            <span>{actionLabel}</span>
          </GlassButton>
        </div>
      </div>
    </div>
  );
}
